<template>
  <div class="ekt-menu-bar-item-box" :class="getCalss">
    <template v-if="menu.position">
      <div class="ekt-menu-bar-item">
        <i :class="['iconfont', menu.icon]"></i>
        <span class="ekt-menu-bar-item-title">{{ menu.name }}</span>
        <HotOrNewVue :menu="menu"/>
      </div>
    </template>
    <template v-else>
      <el-tooltip effect="dark" :content="menu.name" placement="right">
        <div class="ekt-menu-bar-item">
          <i :class="['iconfont', menu.icon]"></i>
        </div>
      </el-tooltip>
    </template>
  </div>
</template>
<script>
import HotOrNewVue from '../HotOrNew.vue';

export default {
  name: "main-menu-item",
  components:{
    HotOrNewVue
  },
  props: {
    menu: {
      type: Object,
      default: function () {
        return {};
      },
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getCalss() {
      return `${this.menu.position} ${this.active ? "actived" : ""}`;
    },
  },
  };
</script>
<style lang="less" scoped>
@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/view/Home/menu/mainItem/index.vue